import { useQuery } from "@tanstack/react-query";
import toast from "react-hot-toast";
import { useTranslation } from "react-i18next";

import { readCurrentTenant, readTenantBySlug } from "../services/tenantApi";

export function useTenantBySlugQuery(slug, onSuccess) {
  const { t } = useTranslation();

  return useQuery({
    queryKey: ["tenant", "slug", slug],
    queryFn: () => readTenantBySlug(slug),
    enabled: !!slug,
    onSuccess,
    onError: (error) => {
      if (error?.response?.status === 404) return;
      toast.error(error.message || t("item.messages.fetchError"));
    },
  });
}

export function useCurrentTenantQuery() {
  const { t } = useTranslation();

  return useQuery({
    queryKey: ["tenant", "current"],
    queryFn: readCurrentTenant,
    onError: (error) => {
      toast.error(error.message || t("item.messages.fetchError"));
    },
  });
}
